import { AdrDto } from "@cradua/data";
import { createAction, props } from "@ngrx/store";

/**
 * Load Adr Collection Actions
 */
export const loadAdr = createAction("[Adr] Load Adr");

export const loadAdrSuccess = createAction(
  "[Adr] Load Adr Success",
  props<{ Adr: AdrDto[] }>(),
);

export const loadAdrFailure = createAction(
  "[Adr] Load Adr Failure",
  props<{ error: any }>(),
);

/**
 * Add Adr to Collection Actions
 */
export const addAdr = createAction(
  "[Adr] Add Adr",
  props<{
    newAdr: AdrDto;
  }>(),
);

export const addAdrSuccess = createAction(
  "[Adr] Add Adr Success",
  props<{ newAdr: AdrDto }>(),
);

export const addAdrFailure = createAction(
  "[Adr] Add Adr Failure",
  props<{ error: any }>(),
);

/**
 * Update Adr Collection Actions
 */
export const updateAdr = createAction(
  "[Adr] Update Adr",
  props<{ updateAdr: AdrDto }>(),
);

export const updateAdrSuccess = createAction(
  "[Adr] Update Adr Success",
  props<{ updateAdr: AdrDto }>(),
);

export const updateAdrFailure = createAction(
  "[Adr] Update Adr Failure",
  props<{ error: any }>(),
);

/**
 * Fetch Adr-record Collection Actions
 */
export const fetchAdrRecord = createAction(
  "[Adr-record] Fetch Adr Record",
  props<{ fetch: any }>(),
);

export const fetchAdrRecordSuccess = createAction(
  "[Adr-record] Fetch Adr Record Success",
  props<{ record: AdrDto[] }>(),
);

export const fetchAdrRecordFailure = createAction(
  "[Adr-record] Fetch Adr Record Failure",
  props<{ error: any }>(),
);

/**
 * Search for record Collection Actions
 */
export const searchAdrRecord = createAction(
  "[Adr] Search  Adr Record",
  props<{ query: string }>(),
);

/**
 * Search for record Collection Actions
 */
export const searchAdrIdRecord = createAction(
  "[Adr] Search  Adr Id Record",
  props<{ query: string }>(),
);

/**
 * Remove Adr Collection Actions
 */
export const removeAdr = createAction(
  "[Adr] Remove Adr",
  props<{ id: string }>(),
);

export const removeAdrSuccess = createAction(
  "[Adr] Remove Adr Success",
  props<{ id: string }>(),
);

export const removeAdrFailure = createAction(
  "[Adr] Remove Adr Failure",
  props<{ error: any }>(),
);



/**
 * Fetch Adr-record By Id Collection Actions
 */
export const fetchByIdAdrRecord = createAction(
  "[Adr-record] Fetch Adr Record By Id",
  props<{ id: string }>(),
);

export const fetchByIdAdrRecordSuccess = createAction(
  "[Adr-record] Fetch Adr Record By Id Success",
  props<{ record: AdrDto[] }>(),
);

export const fetchByIdAdrRecordFailure = createAction(
  "[Adr-record] Fetch Adr Record By Id Failure",
  props<{ error: any }>(),
);



export const clearAdr = createAction("[Adr] Clear Adr");

export const clearAdrSuccess = createAction(
  "[Adr] Clear Adr Success",
  props<{ Adr: AdrDto[] }>(),
);